module.exports = __webpack_public_path__ + "static/media/ic-crossed.4612b3ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-crossed.svg
// module id = 653
// module chunks = 0